import * as React from "react";
import * as z from "zod";
import { useAuth } from "@/lib/auth";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import logoCrypto from "@/assets/logoCrypto.svg";
import {
  TextField,
  Checkbox,
  Link,
  Box,
  Typography,
  Button,
  Grid,
  FormControl,
  InputLabel,
  useTheme,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import inActiveEye from "@/assets/inActiveEye.svg";
import blueEye from "@/assets/blueEye.svg";
import inActiveBlueEye from "@/assets/inActiveBlueEye.svg";
import inActiveMail from "@/assets/InActiveMail.png";
import activeMail from "@/assets/activeMail.svg";
import { useState } from "react";
import { verifyOTPWithOTP } from "../api/verifyOTP";
import { toast } from "react-toastify";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { Form, Formik } from "formik";
import axios from "axios";



const formSchema = z.object({
  firstName: z.string().min(1, "First Name is required").max(100),
  lastName: z.string().min(1, "Last Name is required").max(100),
  nickName: z.string().min(1, "Nick Name is required").max(100),
  email: z
    .string()
    .superRefine((val, ctx) => {
      if (!val || val.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Email is required",
        });
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Invalid email",
        });
      }
    }),

  password: z
    .string()
    .superRefine((val, ctx) => {
      if (!val || val.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Password is required",
        });
      } else if (val.length < 8) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Password must have more than 8 characters",
        });
      }
    }),




  terms: z.boolean().refine(val => val === true, {
    message: "You must accept the terms and conditions",
  }),
});


type FormSchemaType = z.infer<typeof formSchema>;

type RegisterFormProps = {
  onSuccess: (email: any) => void;
};

export const RegisterForm = ({ onSuccess }: RegisterFormProps) => {
  const theme = useTheme();
  const [Icon, setIcon] = React.useState(inActiveMail);
  const [passwordIcon, setPasswordIcon] = React.useState(inActiveEye);
  const [isOpen, setisOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const promoCode = searchParams.get("couponCode");
  const refererId = searchParams.get("refererId");
  const emailId = searchParams.get("emailId");
  const referalData = searchParams.get("referalData");
  const communityToken = searchParams.get("communityToken");
  const [errors, setErrors] = useState<z.ZodIssue[]>([]);
  const [showPassword, setShowPassword] = useState(false);
  const [terms, setTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [decryptedData, setDecryptedData] = useState<{
    promocode?: string;
    referalData?:string;
    promotionType?:string;
  } | null>(null);

  console.log(decryptedData , "decryptedData")
  React.useEffect(() => {
    const fetchDecryptedData = async () => {
      if (!communityToken) return;
      try {
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/promotion/validate`,

          {
            params: { communityToken },
          }
        );
        console.log(res.data.data , "datass")
        if (res.data?.data) {
          setDecryptedData({
            promocode: res.data.data.couponCode,
           referalData:res.data.data._id,
           promotionType:res.data.data.promotionType
           
          });
        }
      } catch (err) {
        console.error("Failed to fetch promotion data:", err);
      }
    };

    fetchDecryptedData();
  }, [communityToken]);




  const handlePassword = () => {
    setShowPassword(!showPassword);
    if (showPassword) setPasswordIcon(inActiveBlueEye);
    else setPasswordIcon(blueEye);
  };

  const onSubmit = async (values: FormSchemaType & { email: string }) => {
    try {
      setLoading(true);
      await verifyOTPWithOTP(values);
      onSuccess(values.email);
    } catch (err: any) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  // Build initialValues depending on presence of communityToken or not
const initialValues: FormSchemaType & {
  promocode?: string | null;
  refererId?: string | null;
  referalData?: string | null;
  promotionType?:string | null;
} = communityToken && decryptedData
  ? {
      firstName: "",
      lastName: "",
      nickName: "",
      email: emailId || "",
      password: "",
      terms: false,
      promocode: decryptedData.promocode || "",
      refererId: null,             
      referalData: decryptedData.referalData || "",
      promotionType:decryptedData.promotionType || ""
    }
  : {
      firstName: "",
      lastName: "",
      nickName: "",
      email: emailId || "",
      password: "",
      terms: false,
      promocode: promoCode || "",
      refererId: refererId || "",
      referalData: referalData || "",
    };
 console.log(initialValues , "datagggj")
  const validate = (values: FormSchemaType) => {
    const result = formSchema.safeParse(values);
    if (!result.success) {
      return result.error.flatten().fieldErrors;
    }
    return {};
  };

  return (
    <>

      <Box
        className="mervlogo"
        sx={{ paddingRight: "10px", paddingTop: "14px" }}
      >
        <Link variant="h3" href="/">
          <img src={logoCrypto} className="logoImage" />
        </Link>
      </Box>
      <Typography component="h1" variant="h1" sx={{ mt: 1 }}>
        Create your Account
      </Typography>
      <Box sx={{ mt: 3.25 }}>
        <Formik
          initialValues={initialValues}
           enableReinitialize={true}
          validate={validate}
          onSubmit={onSubmit}
        >
          {({ errors, touched, handleChange, values }) => (
            <Form>
              <Grid container>
                <Grid container>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth={true}>
                      <InputLabel
                        htmlFor="firstName"
                        shrink={true}
                        sx={{ color: "#FFFFFF" }}
                      >
                        First Name
                      </InputLabel>
                      <TextField
                        margin="normal"

                        autoFocus
                        id="firstName"
                        name="firstName"
                        autoComplete="firstName"
                        onChange={handleChange}
                        value={values.firstName}
                        placeholder="Enter First Name"
                        inputProps={{
                          inputMode: "text",
                        }}
                      />
                      {touched.firstName && errors.firstName && (
                        <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.firstName}</div>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth={true}>
                      <InputLabel
                        htmlFor="lastName"
                        shrink={true}
                        sx={{ color: "#FFFFFF" }}
                      >
                        Last Name
                      </InputLabel>
                      <TextField
                        margin="normal"

                        id="lastName"
                        name="lastName"
                        autoComplete="lastName"
                        onChange={handleChange}
                        value={values.lastName}
                        placeholder="Enter Last Name"
                        inputProps={{
                          inputMode: "text",
                        }}
                      />
                      {touched.lastName && errors.lastName && (
                        <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.lastName}</div>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth={true}>
                      <InputLabel
                        htmlFor="nickname"
                        shrink={true}
                        sx={{ color: "#FFFFFF" }}
                      >
                        Nick Name
                      </InputLabel>
                      <TextField
                        margin="normal"

                        id="nickName"
                        name="nickName"
                        autoComplete="nickName"
                        onChange={handleChange}
                        value={values.nickName}
                        placeholder="Enter Nick Name"
                        inputProps={{
                          inputMode: "text",
                        }}
                      />
                      {touched.nickName && errors.nickName && (
                        <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.nickName}</div>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6} sx={{ pt: 2 }}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor="email"
                      shrink={true}
                      sx={{ color: "#FFFFFF" }}
                    >
                      Email Address
                    </InputLabel>
                    <TextField
                      margin="normal"

                      id="email"
                      name="email"
                      autoComplete="email"
                      onChange={handleChange}
                      value={values.email}
                      placeholder="Enter your Mail Id"
                      onFocus={(e) => {
                        setIcon(activeMail);
                      }}
                      onBlur={(e) => {
                        setIcon(inActiveMail);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment disableTypography position="end">
                            <img src={Icon} alt="inactiveEye" />
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        inputMode: "text", // Ensures the text keyboard is displayed on mobile
                      }}
                    />
                    {touched.email && errors.email && (
                      <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.email}</div>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} sx={{ pt: 2 }}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor="password"
                      shrink={true}
                      sx={{ color: "#FFFFFF" }}
                    >
                      Password
                    </InputLabel>
                    <TextField
                      margin="normal"

                      fullWidth
                      id="password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      autoComplete="password"
                      onChange={handleChange}
                      value={values.password}
                      placeholder="Enter your Password"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            disableTypography
                            position="end"
                            onClick={handlePassword}
                          >
                            <img src={passwordIcon} alt="inactiveEye" />
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        inputMode: "text",
                      }}
                      onFocus={(e) => {
                        setPasswordIcon(blueEye);
                      }}
                      onBlur={(e) => {
                        setPasswordIcon(inActiveEye);
                      }}
                    />
                    {touched.password && errors.password && (
                      <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.password}</div>
                    )}
                  </FormControl>
                </Grid>
                {communityToken&&<Grid item xs={12} sm={6} md={6} sx={{ pt: 2 }}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor="promocode"
                      shrink={true}
                      sx={{ color: "#FFFFFF" }}
                    >
                      Promocode
                    </InputLabel>
                    <TextField
                      margin="normal"
                      id="promocode"
                      name="promocode"
                      autoComplete="promocode"
                      aria-required="false"
                      onChange={handleChange}
                      value={values.promocode}
                      placeholder="Enter Promocode"
                      inputProps={{
                        inputMode: "text",
                      }}
                    />
                  </FormControl>
                </Grid>}
                {/* <Grid item xs={12} sm={6} md={6} sx={{ pt: 2 }}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor="promocode"
                      shrink={true}
                      sx={{ color: "#FFFFFF" }}
                    >
                      Referer's Id
                    </InputLabel>
                    <TextField
                      margin="normal"
                      id="refererId"
                      name="refererId"
                      autoComplete="refererId"
                      aria-required="false"
                      onChange={handleChange}
                      value={values.refererId}
                      placeholder="Enter  Referer's Id"
                      inputProps={{
                        inputMode: "text", // Ensures a text keyboard is displayed on mobile
                      }}
                    />
                  </FormControl>
                </Grid> */}
              </Grid>
              <Grid container>
                <Grid item xs sx={{ p: 0, fontSize: "14px" }}>
                  <Checkbox
                    name="terms"
                    checked={values.terms}
                    onChange={handleChange}
                    disableFocusRipple
                    disableTouchRipple
                    sx={{ px: 0, color: "rgba(255, 254, 236, 0.6)" }}
                    icon={<CheckBoxOutlineBlankIcon htmlColor="#FFFEEC99" />}
                    checkedIcon={<CheckBoxIcon htmlColor="#ff9525" />}
                  />
                  <span
                    style={{
                      color: "rgba(255, 254, 236, 0.6)",
                      paddingLeft: "6px",
                    }}
                  >
                    I confirm that I am at least 18 years old, not a PEP, HOI, or related person, and that I agree to the
                  </span>
                  <Link
                    href="/termsofUse"
                    variant="h3"
                    underline="none"
                    sx={{ pl: "4px", color: "#FF9525" }}
                  >
                    Terms and conditions & Privacy Policy
                  </Link>
                  {touched.terms && errors.terms && (
                    <div style={{ color: "#FF0000", fontSize: "14px" }}>{errors.terms}</div>
                  )}
                </Grid>
              </Grid>

              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    background: "linear-gradient(111deg, #ff9525, #ff5448)",
                    padding: { xs: "10px 15px", sm: "10px 30px", md: "10px 70px" },
                  }}
                >
                  Register
                </Button>
              )}

              <Grid container>
                <Grid
                  item
                  xs
                  sx={{ p: 0, fontSize: "14px", color: "rgba(255, 255, 255, 0.7)" }}
                >
                  Already have an account?
                  <Link
                    href="/auth/login"
                    variant="h3"
                    sx={{ pl: "4px", color: "#FF9525" }}
                    underline="none"
                  >
                    Sign In Now
                  </Link>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default RegisterForm;
